// material-ui
import { Theme } from '@mui/material/styles';

// project-imports
import getColors from '@/utils/GetColors';

// types
import { ExtendedStyleProps } from '@/types/bs-types/extended';

function getColorstyle({ color, theme }: ExtendedStyleProps) {
  const colors = getColors(theme, color);
  const { main } = colors;

  return {
    border: '2px solid ',
    borderColor: main
  };
}

// ==============================|| OVERRIDES - SLIDER ||============================== //

export default function Slider(theme: Theme) {
  return {
    MuiSlider: {
      styleOverrides: {
        track: {
          height: '1px'
        },
        thumb: {
          width: 14,
          height: 14,
          border: '2px solid',
          borderColor: theme.palette.primary.main,
          backgroundColor: theme.palette.background.paper,
          '&.MuiSlider-thumbColorPrimary': getColorstyle({ color: 'primary', theme }),
          '&.MuiSlider-thumbcolorNeutral': getColorstyle({ color: 'neutral', theme }),
          '&.MuiSlider-thumbColorSuccess': getColorstyle({ color: 'success', theme }),
          '&.MuiSlider-thumbColorWarning': getColorstyle({ color: 'warning', theme }),
          '&.MuiSlider-thumbColorInfo': getColorstyle({ color: 'info', theme }),
          '&.MuiSlider-thumbColorError': getColorstyle({ color: 'error', theme })
        },
        mark: {
          width: 4,
          height: 4,
          borderRadius: '50%',
          border: '1px solid',
          borderColor: theme.palette.neutral.light,
          backgroundColor: theme.palette.background.paper,
          '&.MuiSlider-markActive': {
            opacity: 1,
            borderColor: 'inherit',
            borderWidth: 2
          }
        },
        rail: {
          color: theme.palette.neutral.light
        },
        root: {
          '&.Mui-disabled': {
            '.MuiSlider-rail': {
              opacity: 0.25
            },
            '.MuiSlider-track': {
              color: theme.palette.neutral.lighter
            },
            '.MuiSlider-thumb': {
              border: '2px solid',
              borderColor: theme.palette.neutral.lighter
            }
          }
        },
        valueLabel: {
          backgroundColor: theme.palette.neutral.light,
          color: theme.palette.text.primary
        }
      }
    }
  };
}
